import './lazy_load';
import './language_dropdown';
import './tooltip';
import '@wework/ray-core';

import User from 'shared/storage/user';
import { sendTimingEvents } from './timing';
import { onContentLoaded } from './on_content_loaded';
import { fetchGeoData } from './geo';
import { onPolyfillsLoaded, activateClosestElementPolyfill, activateNodelistForEachPolyfill } from './util/polyfills';
import { isIE, isOpera } from './util/user_agent';
import { initNavTrackingListeners } from './nav';
import { setupFooter, listenForFooterInteractionEvents } from './footer';
import { setupPhoneNumbersOnPage, setUpMobileMenuListeners, setupConsentForGDPR } from './on_load_functions_for_main';
import { removeNoJsClass } from './seo';
import { displayBanner } from './alert_banner';
import { showNotificationCard } from './notification_card';
import { sendCountryCodeToGtm } from './analytics';
import { initializeDrift } from './drift/drift';
import { setupToggles } from './toggles';

const instantiateWWWFormUtils = require('@wework/www-form-utils').default;

async function polyfillSticky() {
  const { default: Stickyfill } = await import(/* webpackChunkName: "stickyfill" */ 'stickyfilljs');

  onContentLoaded(() => {
    const elements = document.querySelectorAll('.js-sticky');
    Stickyfill.add(elements);
  });
}

// This is used in our e2e tests
window.__user__ = User;

export default async function clientInit() {
  // We don't want to wait for all of the stuff below to enable DOM node polyfills
  activateClosestElementPolyfill();
  activateNodelistForEachPolyfill();

  fetchGeoData();

  removeNoJsClass();

  const { userId } = window.analyticsGlobals;
  global.analytics.identify(
    userId,
    {},
    {
      integrations: {
        Heap: true
      }
    }
  );

  // send timing events on tick after the load event fires
  window.addEventListener('load', () => setTimeout(sendTimingEvents));

  if (isIE() || isOpera()) {
    await polyfillSticky();
  }

  onPolyfillsLoaded(() => {
    instantiateWWWFormUtils();
  });

  await Promise.all([
    onContentLoaded(initNavTrackingListeners),
    onContentLoaded(setupPhoneNumbersOnPage),
    onContentLoaded(setUpMobileMenuListeners),
    onContentLoaded(setupConsentForGDPR),
    onContentLoaded(setupFooter, document),
    onContentLoaded(listenForFooterInteractionEvents, document),
    onContentLoaded(displayBanner),
    onContentLoaded(showNotificationCard),
    onContentLoaded(sendCountryCodeToGtm),
    onContentLoaded(initializeDrift),
    onContentLoaded(setupToggles)
  ]);
}

clientInit();
